import styles from "./Skeleton.module.css";

interface SkeletonProps {
  variant?: "line" | "title" | "card";
  width?: string;
  height?: string;
  style?: React.CSSProperties;
}

export function Skeleton({ variant = "line", width, height, style }: SkeletonProps) {
  const merged: React.CSSProperties = { ...style };
  if (width) merged.width = width;
  if (height) merged.height = height;
  const variantStyle =
    variant === "title" ? styles.title : variant === "card" ? styles.card : styles.line;
  return (
    <span
      className={`${styles.skeleton} ${variantStyle}`}
      style={merged}
      role="presentation"
      aria-hidden="true"
    />
  );
}

export function SkeletonCardGrid({ count = 4 }: { count?: number }) {
  return (
    <div className={styles.grid}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={styles.gridCard}>
          <Skeleton variant="title" />
          <Skeleton variant="line" />
          <Skeleton variant="line" width="80%" />
        </div>
      ))}
    </div>
  );
}
